import HitListView from './HitListView';

export { reduceHitListViewProps } from './ReduceProps';
export type { THitListViewProps } from './HitListView';

export default HitListView;
